import theme from 'src/theme';

const mono = '"SF Mono", "Fira Code", Menlo, monospace';

export const approvalSx = {
    root: {
        ml: 6,
        mb: 2.5,
        p: 2,
        borderRadius: '14px',
        bgcolor: '#F4F6F9',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        borderLeft: `3px solid ${theme.palette.warning.main}`,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
        animation: 'approvalSlideUp 0.25s ease-out',
        '@keyframes approvalSlideUp': {
            from: {opacity: 0, transform: 'translateY(6px)'},
            to: {opacity: 1, transform: 'translateY(0)'},
        },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 0.75,
    },
    headerIcon: {
        color: theme.palette.warning.main,
        fontSize: 20,
        display: 'flex',
    },
    title: {
        fontSize: '0.9rem',
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    subtitle: {
        fontSize: '0.8rem',
        color: theme.palette.neutral[500],
        mb: 1.25,
    },
    // The agent's own plain-language confirmation sentence (station, day, time, …).
    summary: {
        fontSize: '0.9rem',
        lineHeight: 1.5,
        fontWeight: 500,
        color: theme.palette.text.primary,
        p: 1.25,
        borderRadius: '10px',
        bgcolor: theme.palette.common.white,
        border: '1px solid rgba(0, 0, 0, 0.06)',
    },
    toolRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    // --- Batch mode: the agent's whole plan, one row per action ---
    // The list scrolls rather than growing without bound: a weekly schedule across
    // several stations is ~30 rows, and a card that pushes its own buttons off
    // screen is one the user can't act on.
    planTitle: {
        fontSize: '0.9rem',
        fontWeight: 600,
        color: theme.palette.text.primary,
        mb: 1,
    },
    actionList: {
        maxHeight: 300,
        overflowY: 'auto',
        borderRadius: '10px',
        bgcolor: theme.palette.common.white,
        border: '1px solid rgba(0, 0, 0, 0.06)',
    },
    actionRow: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 1.25,
        px: 1.25,
        py: 0.875,
        '& + &': {
            borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        },
    },
    actionIndex: {
        flexShrink: 0,
        minWidth: 20,
        fontFamily: mono,
        fontSize: '0.75rem',
        color: theme.palette.neutral[500],
        textAlign: 'right',
    },
    actionText: {
        fontSize: '0.85rem',
        lineHeight: 1.45,
        color: theme.palette.text.primary,
        wordBreak: 'break-word',
    },
    toolLabel: {
        fontSize: '0.7rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: theme.palette.neutral[500],
    },
    toolName: {
        fontFamily: mono,
        fontSize: '0.8rem',
        fontWeight: 600,
        color: theme.palette.primary.main,
        wordBreak: 'break-all',
    },
    argsList: {
        mt: 1,
        pt: 1,
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
    },
    argRow: {
        display: 'flex',
        gap: 1,
        fontSize: '0.8rem',
        lineHeight: 1.5,
    },
    argKey: {
        flexShrink: 0,
        fontFamily: mono,
        fontWeight: 500,
        color: theme.palette.neutral[600],
    },
    argValue: {
        fontFamily: mono,
        color: theme.palette.text.primary,
        wordBreak: 'break-word',
    },
    actions: {
        display: 'flex',
        gap: 1,
        justifyContent: 'flex-end',
        mt: 1.75,
    },
    denyButton: {
        textTransform: 'none',
        borderRadius: '10px',
        minWidth: 120,
        bgcolor: theme.palette.common.white,
        color: theme.palette.neutral[600],
        borderColor: 'rgba(0, 0, 0, 0.15)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        '&:hover': {
            bgcolor: theme.palette.common.white,
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.14)',
        },
    },
    approveButton: {
        textTransform: 'none',
        borderRadius: '10px',
        minWidth: 120,
        boxShadow: '0 2px 6px rgba(237, 108, 2, 0.35)',
        '&:hover': {
            boxShadow: '0 4px 10px rgba(237, 108, 2, 0.45)',
        },
    },
};
